import request from "../../utils/request";

export const requestLogin = (params) => {
  return request({ method: "POST", path: "/admin-management/login", params });
};
